import React from "react";
import MaterialModal from "@material-ui/core/Modal";
import { withModal } from "../wrappers/withModal";

const Modal = () => {
  return (
    <div className="outline-none">
      <MaterialModal></MaterialModal>
    </div>
  );
};

export default withModal(Modal);
